/// <reference path="../../libs.ts" />
import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IPerformExtractEncryptionActionOnWorkbooksParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnWorkbooksRequest extends Request<IPerformExtractEncryptionActionOnWorkbooksParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnWorkbooks', {
      ids: ids,
      type: type
    });
  }
}
